import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useEffect, useState } from "react";

const NewsletterModal = ({ isOpen, closeModal, duplicate }) => {
  const [isDuplicate, setisDuplicate] = useState(false);
  useEffect(() => {
    setisDuplicate(duplicate);
  }, [duplicate]);

  return (
    <>
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[1000]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-primary-neutral-400 blur-lg bg-opacity-50 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative z-[1000] transform overflow-hidden bg-white rounded-3xl p-8 flex flex-col items-center shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[460px]">
                  {isDuplicate ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="38"
                      height="41"
                      viewBox="0 0 38 41"
                      fill="none"
                    >
                      <path
                        d="M4.56161 33.8958H9.98661C10.2911 35.6341 11.1988 37.2092 12.55 38.3443C13.9012 39.4794 15.6094 40.1017 17.3741 40.1017C19.1388 40.1017 20.847 39.4794 22.1982 38.3443C23.5494 37.2092 24.4571 35.6341 24.7616 33.8958H30.1866C30.6791 33.9163 31.1707 33.8397 31.6336 33.6702C32.0964 33.5007 32.5213 33.2417 32.884 32.908C33.2467 32.5742 33.5402 32.1724 33.7476 31.7252C33.955 31.2781 34.0723 30.7945 34.0929 30.3021C34.1134 29.8096 34.0367 29.3179 33.8672 28.8551C33.6977 28.3923 33.4387 27.9674 33.105 27.6047C32.7713 27.2419 32.3694 26.9485 31.9223 26.7411C31.4752 26.5337 30.9916 26.4163 30.4991 26.3958V24.4521C32.8197 23.5697 34.758 21.9026 35.9775 19.7401C37.1971 17.5776 37.6209 15.0563 37.1753 12.614C36.7298 10.1716 35.443 7.9624 33.5385 6.36984C31.6339 4.77729 29.2318 3.90196 26.7491 3.89582C25.2385 3.89821 23.7462 4.22651 22.3741 4.85832C22.336 3.53224 21.7726 2.27561 20.808 1.36489C19.8434 0.454164 18.5564 -0.0360565 17.2304 0.00206838C15.9043 0.0401933 14.6476 0.603541 13.7369 1.56818C12.8262 2.53282 12.336 3.81974 12.3741 5.14582V5.52082C9.96878 6.50647 7.91146 8.18607 6.46442 10.3455C5.01737 12.5049 4.24616 15.0464 4.24911 17.6458V26.3958C3.25454 26.4373 2.31718 26.8721 1.64322 27.6047C0.969262 28.3372 0.613917 29.3075 0.655357 30.3021C0.696797 31.2966 1.13163 32.234 1.86419 32.908C2.59676 33.5819 3.56704 33.9373 4.56161 33.8958ZM17.3741 37.6458C16.2663 37.645 15.1901 37.2763 14.3145 36.5975C13.4389 35.9188 12.8136 34.9685 12.5366 33.8958H22.2179C21.9406 34.9695 21.3143 35.9206 20.4375 36.5994C19.5606 37.2783 18.483 37.6464 17.3741 37.6458ZM34.8741 14.5208C34.8741 16.1278 34.3976 17.6987 33.5048 19.0348C32.612 20.371 31.3431 21.4124 29.8584 22.0273C28.3738 22.6423 26.7401 22.8032 25.164 22.4897C23.5879 22.1762 22.1402 21.4024 21.0039 20.2661C19.8676 19.1298 19.0937 17.682 18.7802 16.1059C18.4667 14.5298 18.6276 12.8962 19.2426 11.4115C19.8575 9.92687 20.899 8.65791 22.2351 7.76513C23.5712 6.87234 25.1421 6.39582 26.7491 6.39582C28.904 6.39582 30.9706 7.25184 32.4943 8.77558C34.0181 10.2993 34.8741 12.3659 34.8741 14.5208ZM17.3741 2.64582C17.9697 2.64779 18.5449 2.86229 18.9964 3.25072C19.4478 3.63915 19.7458 4.17598 19.8366 4.76457C18.2092 4.45826 16.539 4.45826 14.9116 4.76457C15.0024 4.17598 15.3004 3.63915 15.7518 3.25072C16.2033 2.86229 16.7786 2.64779 17.3741 2.64582ZM3.66786 29.2646C3.78488 29.1468 3.92419 29.0536 4.07764 28.9903C4.23109 28.927 4.39561 28.8949 4.56161 28.8958H5.49911C5.83063 28.8958 6.14857 28.7641 6.38299 28.5297C6.61741 28.2953 6.74911 27.9773 6.74911 27.6458V17.6458C6.74949 15.4143 7.45243 13.2396 8.75825 11.4301C10.0641 9.62059 11.9064 8.26814 14.0241 7.56457C15.6552 7.01723 17.3961 6.87986 19.0929 7.16457C17.6515 8.66675 16.6832 10.5593 16.3082 12.6071C15.9332 14.6549 16.1681 16.7678 16.9837 18.6832C17.7993 20.5987 19.1596 22.2323 20.8957 23.3813C22.6318 24.5302 24.6672 25.1438 26.7491 25.1458C27.167 25.1441 27.5845 25.1169 27.9991 25.0646V27.6458C27.9991 27.9773 28.1308 28.2953 28.3652 28.5297C28.5996 28.7641 28.9176 28.8958 29.2491 28.8958H30.1866C30.5181 28.8958 30.8361 29.0275 31.0705 29.2619C31.3049 29.4964 31.4366 29.8143 31.4366 30.1458C31.4366 30.4773 31.3049 30.7953 31.0705 31.0297C30.8361 31.2641 30.5181 31.3958 30.1866 31.3958H4.56161C4.23009 31.3958 3.91214 31.2641 3.67772 31.0297C3.4433 30.7953 3.31161 30.4773 3.31161 30.1458C3.30968 29.8166 3.43769 29.4999 3.66786 29.2646Z"
                        fill="url(#paint0_linear_1879_1221)"
                      />
                      <path
                        d="M24.1616 19.1708C24.3949 19.3957 24.7064 19.5212 25.0304 19.5208C25.1968 19.521 25.3616 19.4879 25.5151 19.4235C25.6685 19.3591 25.8076 19.2647 25.9241 19.1458L33.2679 11.6458L31.4804 9.89582L25.0054 16.5146L21.9929 13.6208L20.2554 15.4208L24.1616 19.1708Z"
                        fill="url(#paint1_linear_1879_1221)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_1879_1221"
                          x1="19"
                          y1="0"
                          x2="19"
                          y2="40.1017"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FEB8B1" />
                          <stop offset="1" stop-color="#A5F2F2" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_1879_1221"
                          x1="19"
                          y1="0"
                          x2="19"
                          y2="40.1017"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FEB8B1" />
                          <stop offset="1" stop-color="#A5F2F2" />
                        </linearGradient>
                      </defs>
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M35.417 28.8291C36.2662 28.8291 36.9555 29.5176 36.9555 30.3676C36.9555 31.2176 36.2662 31.906 35.417 31.906C34.567 31.906 33.8785 31.2176 33.8785 30.3676C33.8785 29.5176 34.567 28.8291 35.417 28.8291Z"
                        fill="#FACCAE"
                      />
                      <path
                        d="M5.99393 14.9834C7.16162 14.9834 8.10931 15.9303 8.10931 17.0988C8.10931 18.2672 7.16162 19.2142 5.99393 19.2142C4.82546 19.2142 3.87854 18.2672 3.87854 17.0988C3.87854 15.9304 4.82546 14.9834 5.99393 14.9834Z"
                        fill="#FACCAE"
                      />
                      <path
                        d="M27.6946 29.001L29.2376 35.2571L25.9145 33.2494L23.9062 36.5717L22.2192 29.7301C22.8469 29.7024 23.4578 29.6594 24.0485 29.6024C25.3739 29.4732 26.6 29.2702 27.6946 29.001Z"
                        fill="#BC222E"
                      />
                      <path
                        d="M13.74 31.1169L13.9085 29.2607C14.7792 29.3945 15.6762 29.5046 16.5916 29.5877C17.5377 29.6738 18.4692 29.7276 19.3769 29.7523L18.6893 37.323L16.2039 34.3407L13.2216 36.8261L13.74 31.1169Z"
                        fill="#F797B1"
                      />
                      <path
                        d="M11.0631 28.7206L8.17156 35.1429L6.79541 31.5129L3.16541 32.8891L5.80694 27.0215C6.70618 27.4237 7.71079 27.7953 8.80156 28.1238C9.52002 28.3406 10.2754 28.5406 11.0631 28.7206Z"
                        fill="#73BCFF"
                      />
                      <path
                        d="M33.797 14.2959L37.3401 19.6682L33.5362 18.8874L32.7562 22.6913L28.8785 16.8113C29.6278 16.5082 30.3417 16.1905 31.0162 15.8621C32.0393 15.3635 32.9732 14.8366 33.797 14.2959Z"
                        fill="#DA4A54"
                      />
                      <path
                        d="M26.6177 19.6042L28.0392 25.158L24.6992 23.1795L22.7201 26.5195L20.8346 19.1558C21.7277 18.9865 22.6384 18.7842 23.5593 18.5488C24.45 18.3211 25.3177 18.0696 26.1554 17.7988L26.6177 19.6042Z"
                        fill="#DE7B5C"
                      />
                      <path
                        d="M18.0254 19.5869L17.45 26.6099L14.9384 23.65L11.9777 26.1615L12.5038 19.7393C13.6269 19.8308 14.87 19.8362 16.1992 19.7524C16.7915 19.7146 17.4007 19.6601 18.0254 19.5869Z"
                        fill="#96D8F3"
                      />
                      <path
                        d="M27.6946 6.62598L29.2376 12.8821L25.9145 10.8737L23.9062 14.1967L22.2192 7.35436C22.8469 7.32667 23.4578 7.28359 24.0485 7.22667C25.3739 7.09752 26.6 6.89436 27.6946 6.62598Z"
                        fill="#FED8E4"
                      />
                      <path
                        d="M13.74 8.74092L13.9085 6.88554V6.88477C14.7792 7.01938 15.6762 7.12938 16.5916 7.21246C17.5377 7.29861 18.4692 7.35246 19.3769 7.3763L18.6893 14.9471L16.2039 11.9648L13.2216 14.4509L13.74 8.74092Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M11.0631 6.34551L8.17156 12.7678L6.79541 9.13705L3.16541 10.514L5.80694 4.64551C6.70618 5.04858 7.71079 5.42012 8.80156 5.74859C9.52002 5.96543 10.2754 6.16543 11.0631 6.34551Z"
                        fill="#68CA44"
                      />
                      <path
                        d="M35.6092 4.21484C35.9276 4.21484 36.1861 4.47331 36.1861 4.79177C36.1861 5.11023 35.9276 5.36869 35.6092 5.36869C35.29 5.36869 35.0322 5.11023 35.0322 4.79177C35.0322 4.47323 35.2899 4.21484 35.6092 4.21484Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M35.6092 24.2139C35.9276 24.2139 36.1861 24.4723 36.1861 24.7908C36.1861 25.1093 35.9276 25.3677 35.6092 25.3677C35.29 25.3677 35.0322 25.1093 35.0322 24.7908C35.0322 24.4723 35.2899 24.2139 35.6092 24.2139Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M32.5322 33.0605C32.8507 33.0605 33.1092 33.319 33.1092 33.6375C33.1092 33.9559 32.8507 34.2144 32.5322 34.2144C32.2131 34.2144 31.9553 33.9559 31.9553 33.6375C31.9553 33.319 32.213 33.0605 32.5322 33.0605Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M21.7631 14.5986C22.0815 14.5986 22.34 14.8571 22.34 15.1756C22.34 15.494 22.0815 15.7525 21.7631 15.7525C21.4439 15.7525 21.1862 15.494 21.1862 15.1756C21.1862 14.8571 21.4439 14.5986 21.7631 14.5986Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M18.6861 3.06055C19.0045 3.06055 19.263 3.31901 19.263 3.63747C19.263 3.95593 19.0045 4.21439 18.6861 4.21439C18.3668 4.21439 18.1091 3.95593 18.1091 3.63747C18.1091 3.31893 18.3668 3.06055 18.6861 3.06055Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M11.3784 14.9834C11.6969 14.9834 11.9554 15.2419 11.9554 15.5603C11.9554 15.8788 11.6969 16.1372 11.3784 16.1372C11.0592 16.1372 10.8015 15.8788 10.8015 15.5603C10.8015 15.2419 11.0592 14.9834 11.3784 14.9834Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M10.9938 35.3682C11.3123 35.3682 11.5707 35.6266 11.5707 35.9451C11.5707 36.2635 11.3123 36.522 10.9938 36.522C10.6746 36.522 10.4169 36.2635 10.4169 35.9451C10.4169 35.6266 10.6746 35.3682 10.9938 35.3682Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M7.91689 21.5225C8.23535 21.5225 8.49381 21.7809 8.49381 22.0994C8.49381 22.4178 8.23535 22.6763 7.91689 22.6763C7.59766 22.6763 7.33997 22.4178 7.33997 22.0994C7.33997 21.7809 7.59774 21.5225 7.91689 21.5225Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M2.81187 25.7426C2.64279 25.614 2.60995 25.3727 2.73848 25.2036C2.86702 25.0345 3.10825 25.0017 3.27741 25.1302C8.78341 29.3174 23.1583 30.7456 29.888 27.8863C30.0836 27.8031 30.3093 27.8943 30.3925 28.0899C30.4755 28.2854 30.3844 28.5113 30.1889 28.5943C29.4846 28.8935 28.6763 29.1561 27.7864 29.3747C20.2489 31.2288 7.95395 29.6522 2.81187 25.7426Z"
                        fill="#33383F"
                      />
                      <path
                        d="M2.81187 3.36657C2.64279 3.23803 2.60995 2.99673 2.73848 2.82765C2.86702 2.65857 3.10825 2.62565 3.27741 2.75426C8.80995 6.96111 23.1925 8.35603 29.888 5.51103C30.0836 5.42796 30.3093 5.51911 30.3925 5.71465C30.4755 5.91011 30.3844 6.13596 30.1889 6.21903C23.1166 9.22365 8.48987 7.68411 2.81187 3.36657Z"
                        fill="#33383F"
                      />
                      <path
                        d="M9.97715 19.7351C9.77092 19.6842 9.645 19.4757 9.69584 19.2695C9.74669 19.0633 9.955 18.9373 10.1614 18.9882C10.8664 19.1621 11.6648 19.2855 12.5346 19.3551C18.8292 19.8677 28.1518 17.5408 33.5859 13.9739C34.5645 13.3311 35.3741 12.6757 35.9922 12.0257C36.1385 11.872 36.3819 11.8657 36.5359 12.0121C36.6898 12.1585 36.6959 12.402 36.5496 12.5559C31.637 17.7214 17.4169 21.5694 9.97715 19.7351Z"
                        fill="#33383F"
                      />
                      <path
                        d="M35.417 28.8291C36.2662 28.8291 36.9555 29.5176 36.9555 30.3676C36.9555 31.2176 36.2662 31.906 35.417 31.906C34.567 31.906 33.8785 31.2176 33.8785 30.3676C33.8785 29.5176 34.567 28.8291 35.417 28.8291Z"
                        fill="#FACCAE"
                      />
                      <path
                        d="M5.99393 14.9834C7.16162 14.9834 8.10931 15.9303 8.10931 17.0988C8.10931 18.2672 7.16162 19.2142 5.99393 19.2142C4.82546 19.2142 3.87854 18.2672 3.87854 17.0988C3.87854 15.9304 4.82546 14.9834 5.99393 14.9834Z"
                        fill="#FACCAE"
                      />
                      <path
                        d="M27.6946 29.001L29.2376 35.2571L25.9145 33.2494L23.9062 36.5717L22.2192 29.7301C22.8469 29.7024 23.4578 29.6594 24.0485 29.6024C25.3739 29.4732 26.6 29.2702 27.6946 29.001Z"
                        fill="#BC222E"
                      />
                      <path
                        d="M13.74 31.1169L13.9085 29.2607C14.7792 29.3945 15.6762 29.5046 16.5916 29.5877C17.5377 29.6738 18.4692 29.7276 19.3769 29.7523L18.6893 37.323L16.2039 34.3407L13.2216 36.8261L13.74 31.1169Z"
                        fill="#F797B1"
                      />
                      <path
                        d="M11.0631 28.7206L8.17156 35.1429L6.79541 31.5129L3.16541 32.8891L5.80694 27.0215C6.70618 27.4237 7.71079 27.7953 8.80156 28.1238C9.52002 28.3406 10.2754 28.5406 11.0631 28.7206Z"
                        fill="#73BCFF"
                      />
                      <path
                        d="M33.797 14.2959L37.3401 19.6682L33.5362 18.8874L32.7562 22.6913L28.8785 16.8113C29.6278 16.5082 30.3417 16.1905 31.0162 15.8621C32.0393 15.3635 32.9732 14.8366 33.797 14.2959Z"
                        fill="#DA4A54"
                      />
                      <path
                        d="M26.6177 19.6042L28.0392 25.158L24.6992 23.1795L22.7201 26.5195L20.8346 19.1558C21.7277 18.9865 22.6384 18.7842 23.5593 18.5488C24.45 18.3211 25.3177 18.0696 26.1554 17.7988L26.6177 19.6042Z"
                        fill="#DE7B5C"
                      />
                      <path
                        d="M18.0254 19.5869L17.45 26.6099L14.9384 23.65L11.9777 26.1615L12.5038 19.7393C13.6269 19.8308 14.87 19.8362 16.1992 19.7524C16.7915 19.7146 17.4007 19.6601 18.0254 19.5869Z"
                        fill="#96D8F3"
                      />
                      <path
                        d="M27.6946 6.62598L29.2376 12.8821L25.9145 10.8737L23.9062 14.1967L22.2192 7.35436C22.8469 7.32667 23.4578 7.28359 24.0485 7.22667C25.3739 7.09752 26.6 6.89436 27.6946 6.62598Z"
                        fill="#FED8E4"
                      />
                      <path
                        d="M13.74 8.74092L13.9085 6.88554V6.88477C14.7792 7.01938 15.6762 7.12938 16.5916 7.21246C17.5377 7.29861 18.4692 7.35246 19.3769 7.3763L18.6893 14.9471L16.2039 11.9648L13.2216 14.4509L13.74 8.74092Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M11.0631 6.34551L8.17156 12.7678L6.79541 9.13705L3.16541 10.514L5.80694 4.64551C6.70618 5.04858 7.71079 5.42012 8.80156 5.74859C9.52002 5.96543 10.2754 6.16543 11.0631 6.34551Z"
                        fill="#68CA44"
                      />
                      <path
                        d="M35.6092 4.21484C35.9276 4.21484 36.1861 4.47331 36.1861 4.79177C36.1861 5.11023 35.9276 5.36869 35.6092 5.36869C35.29 5.36869 35.0322 5.11023 35.0322 4.79177C35.0322 4.47323 35.2899 4.21484 35.6092 4.21484Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M35.6092 24.2139C35.9276 24.2139 36.1861 24.4723 36.1861 24.7908C36.1861 25.1093 35.9276 25.3677 35.6092 25.3677C35.29 25.3677 35.0322 25.1093 35.0322 24.7908C35.0322 24.4723 35.2899 24.2139 35.6092 24.2139Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M32.5322 33.0605C32.8507 33.0605 33.1092 33.319 33.1092 33.6375C33.1092 33.9559 32.8507 34.2144 32.5322 34.2144C32.2131 34.2144 31.9553 33.9559 31.9553 33.6375C31.9553 33.319 32.213 33.0605 32.5322 33.0605Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M21.7631 14.5986C22.0815 14.5986 22.34 14.8571 22.34 15.1756C22.34 15.494 22.0815 15.7525 21.7631 15.7525C21.4439 15.7525 21.1862 15.494 21.1862 15.1756C21.1862 14.8571 21.4439 14.5986 21.7631 14.5986Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M18.6861 3.06055C19.0045 3.06055 19.263 3.31901 19.263 3.63747C19.263 3.95593 19.0045 4.21439 18.6861 4.21439C18.3668 4.21439 18.1091 3.95593 18.1091 3.63747C18.1091 3.31893 18.3668 3.06055 18.6861 3.06055Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M11.3784 14.9834C11.6969 14.9834 11.9554 15.2419 11.9554 15.5603C11.9554 15.8788 11.6969 16.1372 11.3784 16.1372C11.0592 16.1372 10.8015 15.8788 10.8015 15.5603C10.8015 15.2419 11.0592 14.9834 11.3784 14.9834Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M10.9938 35.3682C11.3123 35.3682 11.5707 35.6266 11.5707 35.9451C11.5707 36.2635 11.3123 36.522 10.9938 36.522C10.6746 36.522 10.4169 36.2635 10.4169 35.9451C10.4169 35.6266 10.6746 35.3682 10.9938 35.3682Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M7.91689 21.5225C8.23535 21.5225 8.49381 21.7809 8.49381 22.0994C8.49381 22.4178 8.23535 22.6763 7.91689 22.6763C7.59766 22.6763 7.33997 22.4178 7.33997 22.0994C7.33997 21.7809 7.59774 21.5225 7.91689 21.5225Z"
                        fill="#FFD400"
                      />
                      <path
                        d="M2.81187 25.7426C2.64279 25.614 2.60995 25.3727 2.73848 25.2036C2.86702 25.0345 3.10825 25.0017 3.27741 25.1302C8.78341 29.3174 23.1583 30.7456 29.888 27.8863C30.0836 27.8031 30.3093 27.8943 30.3925 28.0899C30.4755 28.2854 30.3844 28.5113 30.1889 28.5943C29.4846 28.8935 28.6763 29.1561 27.7864 29.3747C20.2489 31.2288 7.95395 29.6522 2.81187 25.7426Z"
                        fill="#33383F"
                      />
                      <path
                        d="M2.81187 3.36657C2.64279 3.23803 2.60995 2.99673 2.73848 2.82765C2.86702 2.65857 3.10825 2.62565 3.27741 2.75426C8.80995 6.96111 23.1925 8.35603 29.888 5.51103C30.0836 5.42796 30.3093 5.51911 30.3925 5.71465C30.4755 5.91011 30.3844 6.13596 30.1889 6.21903C23.1166 9.22365 8.48987 7.68411 2.81187 3.36657Z"
                        fill="#33383F"
                      />
                      <path
                        d="M9.97715 19.7351C9.77092 19.6842 9.645 19.4757 9.69584 19.2695C9.74669 19.0633 9.955 18.9373 10.1614 18.9882C10.8664 19.1621 11.6648 19.2855 12.5346 19.3551C18.8292 19.8677 28.1518 17.5408 33.5859 13.9739C34.5645 13.3311 35.3741 12.6757 35.9922 12.0257C36.1385 11.872 36.3819 11.8657 36.5359 12.0121C36.6898 12.1585 36.6959 12.402 36.5496 12.5559C31.637 17.7214 17.4169 21.5694 9.97715 19.7351Z"
                        fill="#33383F"
                      />
                    </svg>
                  )}
                  <div className="flex flex-col items-center space-y-4 mt-10">
                    {!isDuplicate && (
                      <h1 className="text-primary-caarya-medium inter text-[40px] font-medium leading-10 tracking-[1px]">
                        +1
                      </h1>
                    )}
                    <h2 className="text-black poppins text-[20px] leading-9 tracking-[1px] capitalize">
                      {isDuplicate
                        ? "You have already subscribed with us previously!"
                        : "Welcome to the Caarya family!"}
                    </h2>
                    <p className="text-primary-neutral-500 inter text-sm font-light leading-5 tracking-[0.7px]">
                      {isDuplicate
                        ? " We love your enthusiasm though ❤️"
                        : "Do keep an eye on your mail for everything Caarya."}
                    </p>
                  </div>
                  <svg
                    onClick={() => {
                      closeModal();
                    }}
                    className="absolute top-4 right-4"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <path
                      d="M15.8333 5.34199L14.6583 4.16699L9.99996 8.82533L5.34163 4.16699L4.16663 5.34199L8.82496 10.0003L4.16663 14.6587L5.34163 15.8337L9.99996 11.1753L14.6583 15.8337L15.8333 14.6587L11.175 10.0003L15.8333 5.34199Z"
                      fill="#9C9A96"
                    />
                  </svg>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default NewsletterModal;
